import axios from 'Axios'
let UserToken = ''
let UserGid = ''
const Pcode = '80116'
// const host = window.location.host.includes('localhost') ? '' : window.location.host
const host = 'https://aecore.glodon.com'
const $http = axios.create({
    baseURL: `${host}/ops/portal/`,
    timeout: 1000,
    headers: {
        Authorization: btoa(Pcode),
        "Content-Type": "application/json"
    }
})
// xxx: 因为TAIR-14758存在后端技术问题，暂不处理
__PlatformLoginDep.$register((gid, userName) => {
    if (gid) {
        UserGid = gid;
    }
})
export function getArticleList(categoryId) {
    return new Promise((reslove, rej) => {
        let articleFilter = {
            category: categoryId,
            publish: true
        }
        $http.get(`article/list?filter=${encodeURIComponent(JSON.stringify(articleFilter))}&sort=${encodeURIComponent(JSON.stringify({ sort: 0, createdAt: 0 }))}`, {
        }).then(res => {
            reslove(res.data.data.list || [])
        });
    })
}
export function getCategoryId(alias) {
    return new Promise((reslove, rej) => {
        $http.get(`/category/${alias}`, {
        }).then(res => {
            getArticleList(res.data.data.id).then(list => {
                reslove(list)
            })
        });
    })

}
export function protalRead(article) {
    // xxx: 因为TAIR-14758存在后端技术问题，暂不处理
    if (!UserToken) {
        window.location.replace(`${host}/console#/login?redirectUrl=${host}/static/prod-ops/dm/index.html?readedArticle=${article.id}`)
        throw ''
    }
    return new Promise((reslove, rej) => {
        $http.post(`/article/read`, {
            target: article.id,
            targetName: article.name
        }).then(res => {
            console.info(`阅读文章上报{${article.id}:${article.name}}`)
            reslove()
        });
    })
}
export function protalToken() {
    return new Promise((reslove, rej) => {
        $http({
            method: "get",
            baseURL: `${host}/ops/console/`,
            url: '/token'
        }).then(res => {
            UserToken = res.data.data.token
            if (UserToken) {
                $http.defaults.headers.Authorization = btoa([UserGid, Pcode, UserToken].join('_'));
                reslove(UserToken)
            }
            reslove(null)
        }, rejc => {
            rej(rejc)
        });
    })
}
export function getUserToken() {
    return UserToken
}
export function setUserToken(token) {
    UserToken = token
}
export default {
    instance: $http
}